// Dados institucionais da Assegurados usados nos documentos legais.
// >>> PREENCHER os campos entre [colchetes] com os dados reais da empresa. <<<
// Depois de preencher aqui, os dois documentos (Termos de Uso e Política de
// Privacidade) são atualizados automaticamente.

export const COMPANY = {
  // Nome comercial (marca)
  tradeName: 'Assegurados',

  // Razão social e CNPJ da empresa que opera a plataforma.
  legalName: 'Arime Intermediação Comercial Ltda',
  cnpj: '46.492.925/0001-06',

  // Endereço/sede que aparece nos documentos.
  address: 'Rua Caracas, 440, Londrina/PR, CEP 86.050-070',

  // Canais de contato.
  privacyEmail: 'adm@assegurados.com.br', // canal do titular de dados / privacidade
  supportEmail: 'adm@assegurados.com.br',
  supportWhatsapp: '(43) 99682-3513',
  supportWhatsappLink: 'https://api.whatsapp.com/send?phone=5543996823513',

  // Comarca/foro para resolução de disputas (confirmar com advogado).
  jurisdiction: 'Londrina/PR',

  // Data da última atualização exibida no topo dos documentos.
  lastUpdated: '2 de julho de 2026',

  // Domínio principal.
  domain: 'assegurados.com.br',
};
